var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignKeywordsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 113,
    viewBox: "0 0 110 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7805_29770)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7805_29770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z",
    fill: "url(#paint0_linear_7805_29770)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7805_29770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5335 31.5332H23.4668C21.4418 31.5332 19.8002 33.1748 19.8002 35.1999V112.2C19.8002 114.225 21.4418 115.867 23.4668 115.867H86.5335C88.5585 115.867 90.2002 114.225 90.2002 112.2V35.1999C90.2002 33.1748 88.5585 31.5332 86.5335 31.5332Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 38.8662H29.3333C28.1183 38.8662 27.1333 39.8512 27.1333 41.0662C27.1333 42.2812 28.1183 43.2662 29.3333 43.2662H48.4C49.615 43.2662 50.6 42.2812 50.6 41.0662C50.6 39.8512 49.615 38.8662 48.4 38.8662Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4 69.667H29.3333C28.1183 69.667 27.1333 70.652 27.1333 71.867C27.1333 73.082 28.1183 74.067 29.3333 74.067H48.4C49.615 74.067 50.6 73.082 50.6 71.867C50.6 70.652 49.615 69.667 48.4 69.667Z",
    fill: "#EAECF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2002 49.8672H30.8002C29.1801 49.8672 27.8668 51.1805 27.8668 52.8005V60.1339C27.8668 61.7539 29.1801 63.0672 30.8002 63.0672H79.2002C80.8202 63.0672 82.1335 61.7539 82.1335 60.1339V52.8005C82.1335 51.1805 80.8202 49.8672 79.2002 49.8672Z",
    stroke: "#ABCCFE",
    strokeWidth: 1.76923
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2 79.9326H30.8C28.7749 79.9326 27.1333 81.5742 27.1333 83.5993V89.466C27.1333 91.491 28.7749 93.1326 30.8 93.1326H79.2C81.225 93.1326 82.8666 91.491 82.8666 89.466V83.5993C82.8666 81.5742 81.225 79.9326 79.2 79.9326Z",
    fill: "#EAECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8667 23.4663C40.4867 23.4663 41.8 22.153 41.8 20.5329C41.8 18.9129 40.4867 17.5996 38.8667 17.5996C37.2466 17.5996 35.9333 18.9129 35.9333 20.5329C35.9333 22.153 37.2466 23.4663 38.8667 23.4663Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 23.4663C56.6199 23.4663 57.9332 22.153 57.9332 20.5329C57.9332 18.9129 56.6199 17.5996 54.9999 17.5996C53.3798 17.5996 52.0665 18.9129 52.0665 20.5329C52.0665 22.153 53.3798 23.4663 54.9999 23.4663Z",
    fill: "#98A2B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1349 23.4663C72.7549 23.4663 74.0682 22.153 74.0682 20.5329C74.0682 18.9129 72.7549 17.5996 71.1349 17.5996C69.5148 17.5996 68.2015 18.9129 68.2015 20.5329C68.2015 22.153 69.5148 23.4663 71.1349 23.4663Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0661 64.5316C65.0911 64.5316 66.7327 62.89 66.7327 60.8649C66.7327 58.8399 65.0911 57.1982 63.0661 57.1982C61.041 57.1982 59.3994 58.8399 59.3994 60.8649C59.3994 62.89 61.041 64.5316 63.0661 64.5316Z",
    fill: "#EAECF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9314 76.5374C65.3448 76.5374 64.797 76.5374 64.2983 76.5059C63.6841 76.4643 63.0932 76.2542 62.5907 75.8985C62.0882 75.5428 61.6935 75.0554 61.45 74.49L58.3561 68.3754C58.1292 68.1112 58.0159 67.768 58.0409 67.4206C58.0659 67.0733 58.2272 66.7498 58.4896 66.5208C58.7046 66.348 58.9728 66.255 59.2486 66.2576C59.4516 66.2635 59.651 66.3133 59.8329 66.4037C60.0149 66.4941 60.175 66.6229 60.3024 66.7812L61.7074 68.6988L61.7287 68.7238V61.4381C61.7287 61.0766 61.8723 60.73 62.1279 60.4744C62.3835 60.2188 62.7301 60.0752 63.0916 60.0752C63.4531 60.0752 63.7997 60.2188 64.0553 60.4744C64.3109 60.73 64.4545 61.0766 64.4545 61.4381V66.2048C64.4387 66.0294 64.4596 65.8526 64.5158 65.6857C64.5721 65.5188 64.6625 65.3655 64.7813 65.2355C64.9001 65.1055 65.0447 65.0016 65.2059 64.9306C65.367 64.8595 65.5412 64.8229 65.7173 64.8229C65.8934 64.8229 66.0676 64.8595 66.2288 64.9306C66.3899 65.0016 66.5345 65.1055 66.6533 65.2355C66.7721 65.3655 66.8625 65.5188 66.9188 65.6857C66.9751 65.8526 66.9959 66.0294 66.9801 66.2048V67.1984C66.9643 67.023 66.9852 66.8463 67.0414 66.6794C67.0977 66.5125 67.1881 66.3591 67.3069 66.2291C67.4257 66.0991 67.5703 65.9953 67.7315 65.9242C67.8926 65.8532 68.0668 65.8165 68.2429 65.8165C68.419 65.8165 68.5932 65.8532 68.7544 65.9242C68.9155 65.9953 69.0601 66.0991 69.1789 66.2291C69.2977 66.3591 69.3881 66.5125 69.4444 66.6794C69.5007 66.8463 69.5215 67.023 69.5057 67.1984V67.964C69.4899 67.7886 69.5108 67.6118 69.567 67.445C69.6233 67.2781 69.7137 67.1247 69.8325 66.9947C69.9513 66.8647 70.0959 66.7609 70.2571 66.6898C70.4182 66.6188 70.5924 66.5821 70.7685 66.5821C70.9446 66.5821 71.1188 66.6188 71.28 66.6898C71.4411 66.7609 71.5857 66.8647 71.7045 66.9947C71.8233 67.1247 71.9137 67.2781 71.97 67.445C72.0263 67.6118 72.0471 67.7886 72.0313 67.964V72.6112C72.0064 74.0404 71.3603 76.4502 69.0877 76.4502C68.9227 76.4575 67.525 76.5382 65.9344 76.5382L65.9314 76.5374Z",
    fill: "url(#paint1_linear_7805_29770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7805_29770",
    x: 14.4925,
    y: 23.5717,
    width: 81.0154,
    height: 89.0822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.65385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.65385
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7805_29770"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7805_29770",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7805_29770",
    x1: 55,
    y1: 0,
    x2: 55,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7805_29770",
    x1: 65.037,
    y1: 51.8437,
    x2: 48.788,
    y2: 65.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignKeywordsIcon);
export default __webpack_public_path__ + "static/media/AssignKeywordsIcon.a769b341316e6c14f83447a029f81dd3.svg";
export { ForwardRef as ReactComponent };